// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.CancelRenterPaymentSubscriptionWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { CancelRenterPaymentSubscriptionWebApiHandler_cancelRenterPaymentSubscription } from '@zg-rentals/ts-rent-payment-client';

import type {
  CancelRenterPaymentSubscriptionWebApiRequestDto,
  CancelRenterPaymentSubscriptionWebApiResponseDto,
} from '@zg-rentals/ts-rent-payment-client';

export interface CancelRenterPaymentSubscriptionWebApiHandler_cancelRenterPaymentSubscription_Args {
  postData: CancelRenterPaymentSubscriptionWebApiRequestDto;
}

export type CancelRenterPaymentSubscriptionWebApiHandler_cancelRenterPaymentSubscription_Options = UseMutationOptions<
  CancelRenterPaymentSubscriptionWebApiResponseDto,
  unknown,
  CancelRenterPaymentSubscriptionWebApiHandler_cancelRenterPaymentSubscription_Args
>;

/**
 * Cancel Renter's Payment Subscription
 */
export const useCancelRenterPaymentSubscriptionWebApiHandler_cancelRenterPaymentSubscription = ({
  httpClient,
  ...options
}: Omit<CancelRenterPaymentSubscriptionWebApiHandler_cancelRenterPaymentSubscription_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CancelRenterPaymentSubscriptionWebApiHandler_cancelRenterPaymentSubscription_Args) =>
      CancelRenterPaymentSubscriptionWebApiHandler_cancelRenterPaymentSubscription(args.postData, httpClient),
  });
};
